import React from 'react'
import styles from './styles.module.css'
import { useSessionStore } from '../../../../../store/sessionStore'
import Text from '../../../../Text'
import PaymentElement from '../../../../Utils/PaymentElement'

function PaymentInput({ title, subtitle, expanded, stepNumber }) {
  // paymentStartedInfo moved off Overmind to the Zustand session store (Phase C2 part 1).
  const paymentStartedInfo = useSessionStore((s) => s.paymentStartedInfo)

  if (!expanded) {
    return (
      <div className={`${styles.wrapper} ${styles.disabled}`}>
        <div className={styles.titleWrapper}>
          <div className={styles.number}><Text type="heading-9">{stepNumber}</Text></div>
          <Text type="heading-7">{title.toUpperCase()}</Text>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.titleWrapper}>
        <div className={styles.number}><Text type="heading-9">{stepNumber}</Text></div>
        <Text type="heading-4">{title.toUpperCase()}</Text>
      </div>
      <Text type="heading-6">{subtitle}</Text>
      <PaymentElement
        region={paymentStartedInfo.region}
        isLive={paymentStartedInfo.isLive}
        clientSecret={paymentStartedInfo.clientSecret}
      />
    </div>
  )
}

export default PaymentInput
